import React, { Component } from "react";
import { Row, Col, Button, FormControl, Form, Modal } from "react-bootstrap";
import {
  getUsuario,
  ListarUsuarios,
  CadastrarUsuario,
  EditarUsuario,
  DeletarUsuario,
  MudarSenhaUsuario,
} from "../../providers/AdminProvider";
import TBLUsuarios from "../../components/TBLUsuarios";
import Select from "react-select";
import { toast } from "react-toastify";
import { BuscarUsuarioPorNome } from "../../providers/BuscaProvider";

export default class Usuarios extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Usuarios: [],
      usuarioAtivo: null,
      UsuarioSelecionado: null,
      showModalUsuario: false,
      showModalAlert: false,
      showModalSenha: false,
      errorCadastro: "",
      modoEditarUsuario: false,

      error: {
        tipo: null,
        email: "",
        senha: "",
      },

      form: {
        tipo: null,
        email: "",
        senha: "",
      },
      confirmaSenha: "",
      errorSenha: "",
      mensagemAlert: "",
      variantAlert: "",
    };
    this.fileInput = null;

    this.tipos = [
      {
        label: "Admin Master iFeira",
        value: "master",
      },
      {
        label: "Entregador Master",
        value: "entregador_master",
      },
    ];
  }

  confirmaSenha = async () => {
    if (
      this.state.form.senha === this.state.confirmaSenha &&
      this.state.confirmaSenha !== ""
    ) {
      await MudarSenhaUsuario(this.state.form.senha);
      this.handleCloseModalSenha();
      this.handleCloseModalUsuario();
      this.handleShowAlert("Senha atualizada com sucesso", "success");
    } else {
      this.setState({ errorSenha: "Senhas não coincidem *" });
    }
  };

  handleCloseModalUsuario = () => {
    this.setState({ showModalUsuario: false });
    this.limparForm();
  };

  handleShowModalUsuario = () => {
    this.setState({ showModalUsuario: true });
  };

  handleShowAlert = (mensagem, variant) => {
    if (variant === "success") {
      toast.success(mensagem);
    } else if (variant === "error") {
      toast.error(mensagem);
    } else {
      toast.info(mensagem);
    }
  };

  handleCloseModalAlert = () => {
    this.setState({ showModalAlert: false });
    this.limparForm();
  };

  handleShowModalAlert = () => {
    this.setState({ showModalAlert: true });
  };

  pesquisarUsuario = async (value) => {
    if (value === "") {
      const list = await ListarUsuarios();
      this.setState({
        Usuarios: list.filter(
          (u) => u.tipo === "master" || u.tipo === "entregador_master",
        ),
      });
    } else {
      const response = await BuscarUsuarioPorNome(value);
      this.setState({ Usuarios: response });
    }
  };

  cadastrarUsuario = async () => {
    let form = {};
    if (this.validarForm(this.state.form)) {
      form = {
        tipo: this.state.form.tipo.value,
        email: this.state.form.email,
        senha: this.state.form.senha,
      };
      try {
        const response = await CadastrarUsuario(form);
        if (response) {
          await this.listarUsuarios();
          this.limparForm();
          this.handleShowAlert("Usuario cadastrado com sucesso", "success");
        }
      } catch (error) {
        this.handleShowAlert("Erro ao cadastrar Usuario", "error");
      }
    } else {
      this.setState({ errorCadastro: "Informações obrigatórias faltando" });
      return;
    }
  };

  editarUsuario = async () => {
    let form = {};
    if (this.validarForm(this.state.form)) {
      form = {
        email: this.state.form.email,
        tipo: this.state.tipo.form.value,
      };
      try {
        const response = await EditarUsuario(form, this.state.UsuarioSelecionado._id);
        if (response) {
          await this.listarUsuarios();
          this.limparForm();
          this.handleShowAlert("Usuario editado com sucesso", "success");
        }
      } catch (error) {
        this.handleShowAlert("Erro ao editar Usuario", "error");
      }
    } else {
      this.setState({ errorCadastro: "Informações obrigatórias faltando" });
      return;
    }
  };

  deletarUsuario = async () => {
    try {
      const response = await DeletarUsuario(this.state.UsuarioSelecionado._id);
      if (response) {
        await this.listarUsuarios();
        this.limparForm();
        this.handleShowAlert("Usuario deletado com sucesso", "secondary");
      }
    } catch (error) {
      this.handleShowAlert("Erro ao deletar Usuario", "error");
    }
  };

  listarUsuarios = async () => {
    const response = await ListarUsuarios();
    this.setState({
      Usuarios: response.filter(
        (u) => u.tipo === "master" || u.tipo === "entregador_master",
      ),
    });
  };

  async componentDidMount() {
    await this.listarUsuarios();
    const usuarioAtivo = await getUsuario();
    this.setState({ usuarioAtivo: usuarioAtivo });
  }

  validarForm = (form) => {
    let isValid = true;
    let error = this.state.error;
    for (let key in form) {
      if (form[key] === "" || form[key] == null) {
        error = { ...error, [key]: `Campo ${key} obrigatório` };
        isValid = false;
      } else {
        error = { ...error, [key]: "" };
      }
    }

    this.setState({ error });
    return isValid;
  };

  limparForm = () => {
    this.setState({
      UsuarioSelecionado: null,
      showModalUsuario: false,
      showModalAlert: false,
      errorCadastro: "",
      modoEditarUsuario: false,
      errorSenha: "",

      error: {
        tipo: null,
        email: "",
        senha: "",
      },

      form: {
        tipo: null,
        email: "",
        senha: "",
      },

      mensagemAlert: "",
      variantAlert: "",
    });
    this.fileInput ? (this.fileInput.value = "") : (this.fileInput = null);
  };

  preencherFormEdit = (dados) => {
    this.setState({
      form: {
        ...this.state.form,
        tipo: {
          value: dados.tipo,
          label: dados.tipo,
        },
        email: dados.email,
        senha: "",
      },

      modoEditarUsuario: true,
      UsuarioSelecionado: dados,
    });
    this.handleShowModalUsuario();
  };

  handleShowModalSenha = () => {
    this.setState({ showModalSenha: true });
  };
  handleCloseModalSenha = () => {
    this.setState({ showModalSenha: false });
  };

  receberDadosTabela = (tipo, dados) => {
    if (tipo === "editar") {
      this.setState({ UsuarioSelecionado: dados });
      this.preencherFormEdit(dados);
    } else if (tipo === "deletar") {
      this.setState({ UsuarioSelecionado: dados });
      this.handleShowModalAlert();
    } else {
      return;
    }
  };

  render() {
    return (
      <div style={{ margin: 10, marginLeft: 50, marginRight: 50 }}>
        <br></br>
        <Row>
          <Col md={9}>
            <h3>Usuários</h3>
          </Col>
          <Col>
            <Button
              onClick={() => {
                this.handleShowModalUsuario();
              }}
            >
              Cadastrar Usuario Admin
            </Button>
          </Col>
        </Row>
        <br></br>

        <FormControl
          placeholder="Pesquisar Usuarios"
          onChange={(e) => this.pesquisarUsuario(e.target.value)}
        />
        <TBLUsuarios
          data={this.state.Usuarios}
          numRows={14}
          dataCallback={this.receberDadosTabela}
        ></TBLUsuarios>

        <Modal
          size="md"
          show={this.state.showModalUsuario}
          onHide={this.handleCloseModalUsuario}
        >
          <Modal.Header closeButton className="modalHeader">
            <Modal.Title>
              {this.state.modoEditarUsuario ? "Editar Usuario" : "Cadastrar Usuario"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.errorCadastro ? (
              <div>
                <p style={{ color: "red" }}>{this.state.errorCadastro}</p>
              </div>
            ) : null}
            <Form>
              <Form.Group>
                <Form.Label>Tipo *</Form.Label>
                <Select
                  value={this.state.form.tipo}
                  options={this.tipos}
                  onChange={(opt) =>
                    this.setState({ form: { ...this.state.form, tipo: opt } })
                  }
                  placeholder="Tipo"
                />
                {this.state.error.tipo ? (
                  <div>
                    <p style={{ color: "red" }}>{this.state.error.tipo}</p>
                  </div>
                ) : null}
              </Form.Group>
              <Form.Group>
                <Form.Label>Email *</Form.Label>
                <Form.Control
                  value={this.state.form.email}
                  type="email"
                  placeholder="Email do Usuario"
                  onChange={(e) => {
                    this.setState({
                      form: { ...this.state.form, email: e.target.value },
                    });
                  }}
                />
                {this.state.error.email ? (
                  <div>
                    <p style={{ color: "red" }}>{this.state.error.email}</p>
                  </div>
                ) : null}
              </Form.Group>
              {this.state.modoEditarUsuario ? (
                this.state.usuarioAtivo._id === this.state.UsuarioSelecionado._id ? (
                  <div style={{ width: 400, margin: "auto" }}>
                    <Button
                      variant="primary"
                      style={{ marginTop: 30, width: 400 }}
                      onClick={() => {
                        this.handleShowModalSenha();
                      }}
                    >
                      Alterar senha
                    </Button>
                  </div>
                ) : null
              ) : (
                <Form.Group>
                  <Form.Label>Senha *</Form.Label>
                  <Form.Control
                    value={this.state.form.senha}
                    type="password"
                    placeholder="Senha"
                    onChange={(e) => {
                      this.setState({
                        form: { ...this.state.form, senha: e.target.value },
                      });
                    }}
                  />
                  {this.state.error.senha ? (
                    <div>
                      <p style={{ color: "red" }}>{this.state.error.senha}</p>
                    </div>
                  ) : null}
                </Form.Group>
              )}
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => {
                this.handleCloseModalUsuario();
              }}
            >
              Fechar
            </Button>
            {this.state.modoEditarUsuario ? (
              <Button
                variant="primary"
                onClick={() => {
                  this.editarUsuario();
                }}
              >
                {"Editar"}
              </Button>
            ) : (
              <Button
                variant="primary"
                onClick={() => {
                  this.cadastrarUsuario();
                }}
              >
                {"Cadastrar"}
              </Button>
            )}
          </Modal.Footer>
        </Modal>

        <Modal
          size="sm"
          show={this.state.showModalAlert}
          onHide={this.handleCloseModalAlert}
        >
          <Modal.Header closeButton>
            <Modal.Title>Alerta</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>Deseja realmente excluir o Usuario?</p>
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => {
                this.handleCloseModalAlert();
              }}
            >
              Não
            </Button>
            <Button
              variant="primary"
              onClick={() => {
                this.deletarUsuario(this.state.UsuarioSelecionado);
              }}
            >
              Sim
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          style={{ marginTop: 50 }}
          size="sm"
          show={this.state.showModalSenha}
          onHide={() => {
            this.setState({
              errorCadastro: "",
              error: { ...this.state.error, senha: "" },
            });
            this.handleCloseModalSenha();
          }}
        >
          <Modal.Header closeButton className="modalHeader">
            <Modal.Title>Nova senha</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.errorSenha === "Senhas não coincidem *" ? (
              <div>
                <p style={{ color: "red" }}>{this.state.errorSenha}</p>
              </div>
            ) : null}
            <Form.Group>
              <Form.Label>Senha *</Form.Label>
              <Form.Control
                value={this.state.form.senha}
                type="password"
                placeholder="Senha"
                onChange={(e) => {
                  this.setState({ form: { ...this.state.form, senha: e.target.value } });
                }}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Confirmar senha *</Form.Label>
              <Form.Control
                type="password"
                placeholder="Confirmar senha"
                onChange={(e) => {
                  this.setState({ confirmaSenha: e.target.value });
                }}
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => {
                this.handleCloseModalSenha();
              }}
            >
              Fechar
            </Button>
            <Button
              variant="primary"
              onClick={() => {
                this.confirmaSenha();
              }}
            >
              Salvar
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
